import React from 'react';
import {useHistory} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import './css/SignupModal.css';
import './css/Home.css';

import { v4 as uuidv4 } from 'uuid';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";



export function SignupModalView(props) {
    return (
        <div>
            <button className="RegisterButtons1" variant="outlined" color="primary" onClick={props.handleClickOpen}>
                Find Your Circle
      </button>
            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Sign Up</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.error && <i>Passwords do not match! Please try again.</i>}
                        {props.email_error && <i> Please enter a valid ucsd email.</i>}
                        {props.user_error && <i> Please enter a valid username.</i>}
                    </DialogContentText>
                    <form>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="email"
                            label="Email Address"
                            type="email"
                            fullWidth
                            onChange={props.inputEmail}
                            value={props.email}
                        />
                        <TextField
                            margin="dense"
                            id="username"
                            label="Username"
                            type="username"
                            fullWidth
                            onChange={props.inputUser}
                            value={props.username}
                        />
                        <TextField
                            //autoFocus
                            margin="dense"
                            id="password"
                            label="Password"
                            type="password"
                            fullWidth
                            onChange={props.inputPassword}
                            value={props.password}
                        />
                        <TextField
                            //autoFocus
                            margin="dense"
                            id="password"
                            label="Re-enter Password"
                            type="password"
                            fullWidth
                            onChange={props.inputPasswordTwo}
                            value={props.passwordTwo}
                        />
                    </form>

                </DialogContent>
                <DialogActions>
                    <Button onClick={props.signup} color="primary">
                    
                   Register
                    </Button>
                    <Button onClick={props.handleClose} color="primary">
                        Cancel
                    </Button>
                    {props.error && console.log("HAHAHA ERROR GO BR")}
                </DialogActions>
            </Dialog>
        </div>
    );
}